import React, { useEffect, useState } from "react";
import GlobalWrapper from "../../../../components/Wrapper/GlobalWrapper";
import { Box, Paper } from "@mui/material";
import GlobalMultiSelect from "../../../../components/mui/GlobalMultiSelect";
import useResponsive from "../../../../Hooks/useResponsive";
import ActionDetails from "../../../../components/mui/GlobalAnchor/ActionDetails";
import GlobalAnchorList from "../../../../components/mui/GlobalAnchor/GlobalAnchorList";
import { LsqmTableHeader } from "../../../../components/datagrid/Lsqm/LsqmTableHeader";
import GlobalDatagrid from "../../../../components/mui/DataGrid/GlobalDatagrid";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { getLSQMDatas } from "../../../../redux/features/ogdSlice";
import AddOrEditLSQM from "../../../../components/datagrid/Lsqm/AddOrEditLSQM";


export const LeadSquareMapping = () => {
  const mdDown = useResponsive("down", "md");
  const [direction, setDirection] = useState("row");
  const [selectedOgaNames, setSelectedOgaNames] = useState([]);
  const dispatch = useDispatch();
  const { paginationData } = useSelector((state) => state.globalDataGrid);
  const { gridSize, pageNum, rowData, openAnchor, search } = paginationData;
  const { resData, loading } = useSelector((store) => store.ogd);
  const { data, meta } = resData;

  const dispatchParams = {
    paginationData,
  }
  useEffect(() => {
    if (mdDown) {
      setDirection("column");
    } else {
      setDirection("row");
    }
  }, [mdDown]);

  useEffect(() => {
    if(pageNum && gridSize){
      dispatch(getLSQMDatas(dispatchParams));
    }
  }, [gridSize, pageNum, search]);
  return (
    <GlobalWrapper title={"Lead Square Mapping"}
    actions={<AddOrEditLSQM  dispatchParams={{...dispatchParams,paginationData:{...dispatchParams.paginationData,pageNum:1}}}/>}>
      {/* <Box sx={{ display: "flex" }}>
        <Box flex={0.5}>
          <GlobalMultiSelect
            fullWidth={true}
            label={"OGA Filter"}
            arrayState={selectedOgaNames}
            arraySetState={setSelectedOgaNames}
            data={oganame}
            keys={{ id: "id", value: "value" }}
          />
        </Box>
      </Box> */}

      <Box>
        <Paper elevation={3}>
          <GlobalDatagrid
            tableHead={LsqmTableHeader}
            rows={data || []}
            meta={meta?.totalRecords}
            rowUniqueId="sl_no"
            loading={loading}
            rowClick={true}
            actionComponent={
              <>
                <ActionDetails val={rowData?.userName} />
                <GlobalAnchorList
                  label=""
                  component={<AddOrEditLSQM  dispatchParams={dispatchParams} row={rowData} />}
                />
              </>
            }
          />
        </Paper>
      </Box>
    </GlobalWrapper>
  );
};
